import * as React from 'react';

function SvgPaperPlane(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", d: "M21.688 2.314a1.071 1.071 0 00-1.138-.244L2.69 8.83h-.003a1.071 1.071 0 00.044 2.016l.019.006 6.13 2.617a.715.715 0 00.693-.16l9.838-9.167a.315.315 0 11.447.446l-9.168 9.834a.714.714 0 00-.16.694l2.619 6.133a1.05 1.05 0 00.95.75h.044a1.1 1.1 0 001.027-.69l6.759-17.854a1.072 1.072 0 00-.24-1.141z" })));
}

export default SvgPaperPlane;
